import InfoBanner from './info-banner';

export default InfoBanner;
